import React from 'react';
import { motion } from 'framer-motion';
import { ExternalLink, Clock } from 'lucide-react';

export default function NewsCard({ article, index = 0 }) {
  const handleClick = () => {
    window.open(article.url, '_blank', 'noopener,noreferrer');
  };

  return (
    <motion.article
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: index * 0.05 }}
      onClick={handleClick}
      className="group cursor-pointer bg-white/[0.02] hover:bg-white/[0.05] border border-white/5 hover:border-cyan-500/30 rounded-xl overflow-hidden transition-all duration-300"
      data-testid={`news-card-${article.id}`}
    >
      {/* Thumbnail */}
      <div className="relative aspect-video overflow-hidden">
        <img
          src={article.image}
          alt={article.title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
          onError={(e) => {
            e.target.src = 'https://images.unsplash.com/photo-1504711434969-e33886168f5c?w=400&q=80';
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" />
        
        {/* Source badge */}
        <div className="absolute top-3 left-3">
          <span className="px-2 py-1 text-xs font-medium bg-black/50 backdrop-blur-sm text-white rounded-full">
            {article.source}
          </span>
        </div>
        
        {/* External link icon */}
        <div className="absolute top-3 right-3 opacity-0 group-hover:opacity-100 transition-opacity">
          <span className="p-1.5 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center">
            <ExternalLink className="w-3.5 h-3.5 text-white" />
          </span>
        </div>
      </div>

      {/* Content */}
      <div className="p-4">
        <h3 className="font-medium text-white text-sm leading-snug line-clamp-2 group-hover:text-cyan-400 transition-colors mb-2">
          {article.title}
        </h3>
        
        {article.description && (
          <p className="text-xs text-gray-400 line-clamp-2 mb-3">
            {article.description}
          </p>
        )}
        
        {/* Meta */}
        <div className="flex items-center justify-between text-xs text-gray-500">
          <div className="flex items-center gap-1">
            <Clock className="w-3 h-3" />
            <span>{article.time_ago}</span>
          </div>
          {article.author && article.author !== 'Unknown' && (
            <span className="truncate max-w-[100px]">{article.author}</span>
          )}
        </div>
      </div>
    </motion.article>
  );
}
